<template>
  <div
    class="w-full flex items-center lg:ml-auto py-1"
    :class="showTrustpilotScoreInHeader ? 'lg:w-[33rem]' : 'lg:w-52'"
  >
    <TrustpilotMicroCombo
      v-if="showTrustpilotScoreInHeader"
      :show-widget="showWidget"
      class="h-full w-full flex justify-center lg:justify-end items-center shrink-0"
    />
    <TrustpilotMicroButton
      v-else
      :show-widget="showWidget"
      class="h-full w-full flex justify-center lg:justify-end items-center shrink-0"
    />
  </div>
</template>

<script lang="ts">
import { TRUSTPILOT_MICRO_BUTTON_ID, TRUSTPILOT_MICRO_COMBO_WIDGET_ID } from '~~/constants/trustPilot';
import { TRUSTPILOT_MICRO_BUTTON_WIDGET_HEIGHT, TRUSTPILOT_MICRO_COMBO_WIDGET_HEIGHT } from '~~/constants/ui';

export default defineComponent({
  name: 'TrustpilotMicroComboOrButton',

  setup () {

    const { showTrustpilotScoreInHeader, isLoaded } = useStoreVsfExtended();
    const { showTrustPilotWidget } = useTrustPilotWidget();

    const trustpilotWidgetId = computed(() => {

      return showTrustpilotScoreInHeader.value
        ? TRUSTPILOT_MICRO_COMBO_WIDGET_ID
        : TRUSTPILOT_MICRO_BUTTON_ID;
    
    });

    const trustpilotWidgetHeight = computed(() => {

      return showTrustpilotScoreInHeader.value
        ? TRUSTPILOT_MICRO_COMBO_WIDGET_HEIGHT
        : TRUSTPILOT_MICRO_BUTTON_WIDGET_HEIGHT;
    
    });

    const showWidget = computed(() => showTrustPilotWidget.value && isLoaded.value);

    return {
      showWidget,
      isLoaded,
      trustpilotWidgetId,
      trustpilotWidgetHeight,
      showTrustPilotWidget,
      showTrustpilotScoreInHeader,
    };
  
  },
});


</script>
